<template>
    <div class="container">
        <div class="content" id="printContent">
            <div class="header tac fs30 fwb">
                <span class="title">项目合同</span>
                <div class="logo">
                    <img :src="system.logo" alt="" />
                    <span class="fs14">元素魔方</span>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="row mgt20">
                <div class="fl">
                    <span class="">甲方：</span>
                    <span class="input">{{ invoice.name }}</span>
                </div>
                <div class="fr">
                    <span class="">合同编号：</span>
                    <span class="input wid120 tac">{{ invoice.invoice_no }}</span>
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
            <div class="row">
                <div class="fl">
                    <span class="">乙方：</span>
                    <span class="input">{{ invoice.header_name }}</span>
                </div>
                <div class="fr">
                    <span class="">签订日期：</span>
                    <span class="input wid120 tac">{{ invoice.create_time.substr(0, 10) }}</span>
                </div>
                <div class="clearfix"></div>
            </div>

            <div class="clearfix"></div>

            <div class="desc">一、项目名称、数量、金额</div>

            <table class="mgt10">
                <thead>
                    <tr>
                        <th width="40%">项目名称</th>
                        <th width="20%">单价</th>
                        <th width="20%">数量</th>
                        <th width="20%">金额</th>
                    </tr>
                </thead>
                <tbody>

                    <tr class="border" v-for="(item, index) in invoice.items" :key="index">
                        <td class="tac">{{ item.body }}</td>
                        <td class="tac">{{ item.price }}</td>
                        <td class="tac">{{ item.num || '1' }}</td>
                        <td class="tac">{{ item.price }}</td>
                    </tr>

                    <tr class="border">
                        <td colspan="1" class="tac">合计金额(小写)</td>
                        <td colspan="3" class="tac">{{ invoice.price }}</td>
                    </tr>
                    <tr class="border">
                        <td colspan="1" class="tac">合计金额人民币(大写)</td>
                        <td colspan="3" class="tac">{{ invoice.big_price }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="desc">二、测试要求：测试方提供真实可靠的数据</div>
            <div class="desc">三、测试周期：测试方收到试样的次日起算10个工作日内</div>
            <div class="desc">四、结算方式及期限：乙方提供发票为 <span class="input">电子发票({{ invoice.type_name
                    }})</span>，甲方根据发票在20个工作日内向乙方完成转账</div>
            <div class="desc">五、违约责任：本合同发生争议，双方协商解决;协商不成向起诉方所在地有管辖权人民法院起诉。</div>
            <div class="desc">六、本合同双方代表签字盖章后生效，经传真亦可生效。</div>
            <div class="desc">七、未尽事宜双方协商解决，此协议一式2份，测试方执1份，需求方执1份，具有同等法律效力。</div>


            <table class="mgt20">
                <thead>
                    <tr>
                        <th width="50%">甲方</th>
                        <th width="50%">乙方</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>单位名称：{{ invoice.name || '--' }}</td>
                        <td>单位名称：{{ invoice.header_name || '--' }}</td>
                    </tr>
                    <tr>
                        <td>法定代表人：{{ invoice.name1 || '--' }}</td>
                        <td>法定代表人：{{ invoice.header_owner_name || '--' }}</td>
                    </tr>
                    <tr>
                        <td>开户银行：{{ invoice.bank_name || '--' }}</td>
                        <td>开户银行：{{ invoice.header_bank_name || '--' }}</td>
                    </tr>
                    <tr>
                        <td>账号：{{ invoice.bank_account || '--' }}</td>
                        <td>账号：{{ invoice.header_bank_account || '--' }}</td>
                    </tr>
                    <tr>
                        <td>经办人：{{ invoice.user_name || '--' }}</td>
                        <td>经办人：{{ invoice.header_linkman || '--' }}</td>
                    </tr>
                    <tr>
                        <td>电话：{{ invoice.tel || '--' }}</td>
                        <td>电话：{{ invoice.header_linkman || '--' }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="bottom">
                <img class="chapter" :src="invoice.header_chapter" alt="" />
            </div>

        </div>

        <div class="footer mgt100 flex-xy-center">
            <div>
                <el-button type="primary" @click="handleDownload">下载合同</el-button>
            </div>
            <div class="mgl50">
                <el-button type="primary" v-print="'#printContent'" :loading="loading">打印合同</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { getPrintPreview } from "@/api/invoice";

export default {
    name: 'InvoicePreviewList',
    components: {

    },
    data() {
        return {
            loading: true,
            invoice: {
                create_time: ''
            },
            invoiceId: 0,
            system: {},
            account: {},
        };
    },
    computed: {

    },
    created() {
        this.invoiceId = this.$route.query.id;
        this.getPrintPreview();
    },
    methods: {
        getPrintPreview() {
            getPrintPreview({ id: this.invoiceId }).then(res => {
                this.loading = false;
                this.invoice = res.data.invoice;
                this.system = res.data.system;
                this.account = res.data.account;
            }).catch((err) => {

            });
        },
        handleDownload() {
            window.open(this.invoice.contract_url, '_blank');
        },
    }
};
</script>

<style media="printContent">
@page {
    margin: 5mm;
}
</style>
<style lang="scss" scoped>
.container {
    width: 700px;
    margin: 0 auto;
    padding-bottom: 30px;
    background-color: #FFF;
}

.content {
    padding: 30px 30px 0 30px;
}

.header {
    position: relative;
}

.header .title {
    letter-spacing: 5px;
}

.header .logo {
    position: absolute;
    left: 0px;
    top: 0px;
    font-weight: normal;
    letter-spacing: 2px;
    vertical-align: middle;
}

.header .logo img {
    width: 40px;
    height: 40px;
    vertical-align: middle;
}

.input {
    padding: 0px 20px 5px 10px;
    border-bottom: 1px solid #666;
    display: inline-block;
    margin-top: 3px;
}

.desc {
    font-size: 13px;
    margin-top: 10px;
}

table {
    width: 100%;
}

table th {
    font-weight: bold;
}

table td,
table th {
    padding: 10px 20px;
    border: 1px solid #666;
}

.row {
    padding-top: 10px;
    font-size: 13px;
}

.wid120 {
    width: 120px;
    display: inline-block;
}

.bottom {
    position: relative;
}

.chapter {
    position: absolute;
    right: 0px;
    top: -170px;
    width: 200px;
    height: 200px;
    z-index: 1;
}

.clearfix::after {
    content: "";
    display: table;
    clear: both;
}
</style>
